import { createContext } from 'react';

interface IExpandableTableContext {
  rowsCount: number | null;
}

export const ExpandableTableContext = createContext<IExpandableTableContext | null>(null);
